import React from 'react';
import PropTypes from 'prop-types';
import {d3} from 'dc';

export function mergeProptypesFunctions(props, propName, componentName, propTypeFunction1, propTypeFunction2) {
    var result1 = propTypeFunction1(props, propName, componentName);
    var result2 = propTypeFunction2(props, propName, componentName);
    if(result1 != null) {
      return result1;
    }
    else {
      return result2;
    }
}

export function mergeProptypes(propTypes1, propTypes2) {
    return Object.assign({},propTypes1,propTypes2);
}

export function mergeState(state1, state2) {
    return Object.assign({},state1,state2);
}

export function rangePropType() {
    return PropTypes.shape({
        value: PropTypes.any,
        operator: PropTypes.oneOf(['>','>=','<','<=','==','!=',"like"]).isRequired,
        lastLogicOperator: PropTypes.oneOf(['OR','AND']),
      });
}

export function wrapValue(wrapper, value) {
    return wrapper.replace(/%v/g,value);
}

export function getFormatFunction(valueFormatObject) {
    var functionReturned = (function(v) { return v;});

    if(valueFormatObject.format != "") {
      if(valueFormatObject.type == "DATE_TIME") {
        functionReturned = d3.time.format(valueFormatObject.format);
      }
      else if(valueFormatObject.type == "DATE_TIME_UTC") {
        functionReturned = (function(v) {
          var date = new Date(v);
          date.setTime(v+date.getTimezoneOffset()*60000);
          var formatter = d3.time.format(valueFormatObject.format);
          return formatter(date);
        });
      }
      else if(valueFormatObject.type == "NUMBER" || valueFormatObject.type == "PROGRESS_NUMBER") {
        functionReturned = (function(v) {
          if(isNaN(v)) {
            return valueFormatObject.noDataValue;
          }
          var value = v;

          switch(valueFormatObject.factorOperator) {
            case "*": value = value*valueFormatObject.factor; break;
            case "/": value = value/valueFormatObject.factor; break;
          }

          if(valueFormatObject.format == "hh:mm") {
            var hour = Math.floor(value);
            var minute = Math.floor(((value - hour) * 60));
            var hourString = "00".substring(0, 2 - hour.toString().length) + hour + "h";
            var minuteString = "00".substring(0, 2 - minute.toString().length) + minute + "m";
            return hourString + ":" + minuteString;
          }
          return (d3.format(valueFormatObject.format))(value)
        });
      }
      else if(valueFormatObject.type == "STRING") {
        if(valueFormatObject.format == "CLEAN") {
          functionReturned = (function(v) { 
            var splittedLabel = v.split("|");
            if(splittedLabel.length>1) {
              return splittedLabel[1];
            }
            return v; 
          });
        }
        else {
          functionReturned = (function(v) { return v;});
        }
      }                
    }

    var functionReturnedWrapper = (function(v) {
      if(v == null) {
        return "N/A";
      }
      return functionReturned(v);
    });

    return functionReturnedWrapper;
}

export function valueFormatPropType() {
    return PropTypes.shape({
          type: PropTypes.oneOf(['NUMBER','PROGRESS_NUMBER','DATE_TIME_UTC','DATE_TIME','STRING','TRAVEL_PATH']), //Travel path only for travelDataTable
          format: PropTypes.string.isRequired, //special format hh:mm to show an hour (integer) like XXhr:XXm
          factor: PropTypes.number,
          factorOperator: PropTypes.oneOf(['*','/'])
        });
}

export function dashboardLinkConfigPropType() {
      linkConfig: PropTypes.shape({
        dashboard_id: PropTypes.string.isRequired,
        where: PropTypes.string,
        serializedParams: PropTypes.string,
        title: PropTypes.string,
        className: PropTypes.string
      });
}

export function getValueFormatDefault() {
    return {type:"",format:"",factor:1,factorOperator:"*"};
}

export function getDashboardLinkConfigDefault() {
    return {dashboard_id: null, where: "MAIN_VIEW", serializedParams: "null",title: "",className: ""};
}

export function createIdLookups(array) {
  var lookup = {};
  for(var i=0;i<array.length;i++) {
    lookup[array[i].id] = array[i];
  }

  return lookup;
};

export function asyncFunction(executeFunction) {
  return new Promise(
        function (resolve, reject) {
          var timeOut = window.setTimeout(function() {
            executeFunction();
            resolve(true);
            clearTimeout(timeOut);
          }, 1);
        });
}

export function assignProps(objTo, objFrom, propList) {
  for(var p in propList) {
    var propName = propList[p];
    if(propName in objFrom) {
      objTo[propName] = objFrom[propName];
    }
  }
  return objTo;
}

export function objsToArrs(arrObjs, propList) {
  let rows = [];
  for(let oi in arrObjs) {
    let obj = arrObjs[oi];
    let row = [];
    for(let p in propList) {
      row.push(obj[propList[p]]);
    }
    rows.push(row);
  }
  return rows;
}

export function getPropValue(list, propName, id, defaultVal, idName) {
  if(idName === undefined)
    idName = '_id';
  if(id !== undefined)
    for(var n in list) {
      var ele = list[n];
      if(ele[idName] == id)
        return ele[propName];
    }
  return defaultVal;
}

export function isIE () {
  return navigator.appVersion.indexOf("MSIE") != -1
}

export function getIEVersion () {
    var version = 999;
    if (navigator.appVersion.indexOf("MSIE") != -1) {
      version = parseFloat(navigator.appVersion.split("MSIE")[1]);
    }
    return version;
}

export function getFormatDay(){
  var date = new Date();
  var minutes = date.getMinutes();
  var hour = date.getHours();
  var year = date.getFullYear();
  var month = date.getMonth()+1; // beware: January = 0; February = 1, etc.
  var day = date.getDate();

  if(day < 10){
    day = "0"+day;
  }
  if(month < 10){
    month = "0"+month;
  }
  if(hour < 10){
    hour = "0"+hour;
  }
  if(minutes < 10){
    minutes = "0"+minutes;
  }
  var time = hour+":"+minutes+" del "+day+"/"+month+"/"+year;

  return time;
}

export function computeDistanceBetween(point1, point2) 
{
  var R = 6371; // km
  var dLat = toRad(point2[0]-point1[0]);
  var dLon = toRad(point2[1]-point1[1]);
  var lat1 = toRad(point1[0]);
  var lat2 = toRad(point2[0]);

  var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c;
    //in m
  return Math.abs(d*1000);
}

// Converts numeric degrees to radians
function toRad(Value) 
{
    return Value * Math.PI / 180;
}

export function promiseSerial(funcs,i=0) {
  if(i<funcs.length) {
    return Promise.resolve(new Promise(funcs[i])).then(values => {
      return promiseSerial(funcs,i+1);
    });
  }
  else {
    return Promise.resolve(true);
  }
}



// WEBPACK FOOTER //
// ./source/client/components/common/graphs/crossfilterGraphs/util/utilFunctions.js